import { render, staticRenderFns } from "./ImageTemplateAdmin.vue?vue&type=template&id=065e7882&scoped=true&"
import script from "./ImageTemplateAdmin.vue?vue&type=script&lang=js&"
export * from "./ImageTemplateAdmin.vue?vue&type=script&lang=js&"
import style0 from "./ImageTemplateAdmin.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ImageTemplateAdmin.vue?vue&type=style&index=1&id=065e7882&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065e7882",
  null
  
)

export default component.exports